import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'agreement-services-grid',
  templateUrl: './agreement-services-grid.component.html',
  styleUrls: ['./agreement.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class AgreementServicesGridComponent implements OnInit {
  private _datas: any[];
  @Output() datasChange: EventEmitter<any[]>;
  @Input('datas')
  public set datas(value: any[]) {
    this._datas = value;
    this.datasChange.emit(value);
  }
  public get datas(): any[] {
    return this._datas;
  }

  private _isLoaded: boolean;
  @Output() isLoadedChange: EventEmitter<boolean>;
  @Input('isLoaded')
  public set isLoaded(value: boolean) {
    this._isLoaded = value;
    this.isLoadedChange.emit(value);
  }
  public get isLoaded(): boolean {
    return this._isLoaded;
  }

  @Output() onChangeIsServiceOfferedChange: EventEmitter<any>;

  constructor() {
    this.isLoadedChange = new EventEmitter<boolean>();
    this.datasChange = new EventEmitter<any[]>();
    this.onChangeIsServiceOfferedChange = new EventEmitter<any>();
  }

  ngOnInit() {}

  changeIsServiceOffered(data) {
    this.onChangeIsServiceOfferedChange.emit(data);
  }

  getRowStyle(data, index) {
    if (!data) return null;

    if (data.isServiceOffered == true) {
      return 'service-offered';
    }

    if (data.isServiceOffered == false) {
      return 'no-service-offered';
    }

    return null;
  }
}
